import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  useAddRfidMasterMutation,
  useBulkUploadRfidMasterMutation,
} from "../toolkitServices/rfidMasterApi";
import RfidMasterForm from "../components/RfidMasterForm";

const CreateRfidMaster = () => {
  const navigate = useNavigate();

  const [addRfidMaster, { isLoading, isSuccess, error, data }] =
    useAddRfidMasterMutation();

  const [bulkUploadRfidMaster, { isLoading: isBulkUploading }] =
    useBulkUploadRfidMasterMutation();

  useEffect(() => {
    if (isSuccess && (data?.success ?? true)) {
      toast.success("RFID Master added!");
      navigate("/organisation/rfid-master/list");
    }
  }, [isSuccess, data, navigate]);

  useEffect(() => {
    if (error) {
      const msg =
        error?.data?.msg ||
        error?.data?.message ||
        error?.error ||
        "Error adding RFID Master!";
      toast.error(msg);
    }
  }, [error]);

  const handleSubmit = async (payload) => {
    try {
      await addRfidMaster(payload).unwrap();
    } catch {}
  };

  const handleBulkUpload = async (formData) => {
    try {
      const res = await bulkUploadRfidMaster(formData).unwrap();
      toast.success(res?.msg || "Excel uploaded successfully!");
      navigate("/organisation/rfid-master/list");
    } catch (err) {
      const msg =
        err?.data?.msg ||
        err?.data?.message ||
        err?.error ||
        "Excel upload failed!";
      toast.error(msg);
    }
  };

  return (
    <RfidMasterForm
      title="Create RFID Master"
      subtitle="Add RFID to EPC mapping for this tenant."
      onSubmit={handleSubmit}
      isLoading={isLoading}
      isBulkUploading={isBulkUploading}
      onBulkUpload={handleBulkUpload}
      submitLabel="Submit"
      backTo="/organisation/rfid-master/list"
      showBulkActions
    />
  );
};

export default CreateRfidMaster;